<template>
  <div
    class='individuals__list'
  >
    <IndividualCard
      class="individuals__individual"
      v-for="result in results"
      :key="result.id"
      :person="result"
    />
  </div>
</template>

<script>

import IndividualCard from "../company/individual-card";

import elasticSearch from "../lib/elastic-search";

export default {

  components: {
    IndividualCard,
  },

  props: {
    isLoggedIn: {
      type: Boolean
    },
    favorites: {
      type: Array
    }
  },

  data() {
    return {
      index: "companies",

      dynamicFavorites: this.favorites,
      response: null,
    };
  },

  created() {
    const promise = this.fetchResults();
    promise.then(response => {
      this.isLoading = false;
      this.response = response;
    });
  },


  computed: {
    results() {
      if (this.response) {
        return this.response.hits.hits.map(el => {
          return {
            ...el._source
          };
        });
      } else return [];
    },

    query() {
      return {
        sort: [
          { featured_at: "desc" },
        ],
        query: {
          bool: {
            must: [
              { match: { featured: true } },
            ]
          }
        }
      };
    }
  },

  methods: {
    fetchResults() {
      this.isLoading = true;

      const promise = elasticSearch({
        index: 'users',
        size: 4,
        body: this.query
      });

      return promise;
    },
  }
};
</script>

<style lang="scss" scoped>
.individuals__list {
  margin: 48px 0 48px;
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  @include min-width(760px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/featured-individuals.vue?0f835122